import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { Observable } from 'rxjs';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BalanceImportModel } from 'src/app/models/imports/balace-import.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';

@Injectable({
  providedIn: 'root'
})
export class RentalBalanceService {

  constructor(private _httpClient: HttpClient) { }
  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.rentalBalance.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalBalance.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  importBalance(balanceImports: Array<BalanceImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalBalance.ImportBalances}`, balanceImports);
  }

  reverseImportBalances(branchId: number): Observable<boolean> {
    return this._httpClient.delete<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalBalance.ReverseImportBalances}/${branchId}`);
  }

  getColumnsForRentalBalance(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalBalance.GetColumnsForRentalBalanceAsync}`);
  }
}
